import type { Review, ReviewSort, StarRating } from '../types/review';

export type ReviewSummary = {
  count: number;
  average: number;
  distribution: Record<StarRating, number>;
};

export function summarize(list: Review[]): ReviewSummary {
  const published = list.filter((r) => r.status === 'published');
  const distribution: Record<StarRating, number> = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  published.forEach((r) => {
    distribution[r.rating] += 1;
  });
  const count = published.length;
  const average = count ? Math.round((published.reduce((s, r) => s + r.rating, 0) / count) * 10) / 10 : 0;
  return { count, average, distribution };
}

export function sortReviews(list: Review[], sort: ReviewSort): Review[] {
  const copy = [...list];
  if (sort === 'highest') return copy.sort((a, b) => b.rating - a.rating || b.date.localeCompare(a.date));
  if (sort === 'lowest') return copy.sort((a, b) => a.rating - b.rating || b.date.localeCompare(a.date));
  return copy.sort((a, b) => b.date.localeCompare(a.date));
}

export function formatReviewDate(iso: string, lang: 'en' | 'es') {
  return new Date(iso).toLocaleDateString(lang === 'es' ? 'es-US' : 'en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
